namespace TotalPoll {
    import ISCEService = angular.ISCEService;
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'questions-component-template',
        bindings: {
            items: '=',
        }
    })
    class QuestionsComponent {
        public currentQuestion;
        public items: any[];
        public bulkInsert = false;
        public bulkQuestions = '';
        public bulkChoices = '';
        public bulkQuestionsAndChoices = [];
        public bulkSeperator = '\\n\\n';
        public previewQuestion = false;

        constructor(private UniqueIdService: UniqueIdService, private $sce: ISCEService) {

        }

        $onChanges() {
            if (!this.currentQuestion) {
                if (this.items.length === 0) {
                    this.addQuestion();
                }
                this.setCurrentQuestion(this.items.length - 1);
            }
        }

        addQuestion() {
            this.items.push({
                uid: this.UniqueIdService.generate(),
                content: '',
                settings: {
                    selection: {
                        minimum: 1,
                        maximum: 1,
                    }
                },
                choices: []
            });

            this.setCurrentQuestion(this.items.length - 1)
        }

        escape(content) {
            return this.$sce.trustAsHtml(String(content).replace(/<[^>]+>/gm, '').slice(0, 100).concat('...'));
        }

        showBulkInsert() {
            this.bulkInsert = true;
        }

        hideBulkInsert() {
            this.bulkInsert = false;
        }

        parseBulkInsert() {
            this.bulkQuestionsAndChoices = [];

            const questions = this.bulkQuestions.split(this.bulkSeperator.replaceAll('\\n', "\n"));
            const genericChoices = this.bulkChoices.split("\n");

            for (const question of questions) {
                const parts = question.split("\n");
                const questionContent = parts.filter(part => part.charAt(0) !== '*' && part.trim()).join('\n');

                if (questionContent) {
                    this.bulkQuestionsAndChoices.push({
                        uid: this.UniqueIdService.generate(),
                        content: questionContent,
                        settings: {
                            selection: {
                                minimum: 1,
                                maximum: 1,
                            }
                        },
                        choices: [
                            ...parts.filter(part => part.charAt(0) === '*')
                                .map((part) => {
                                    return {
                                        uid: this.UniqueIdService.generate(),
                                        type: 'text',
                                        label: part.slice(1).trim(),
                                        votes: 0,
                                        votesOverride: 0,
                                        collapsed: false,
                                        visibility: true
                                    }
                                }),
                            ...genericChoices.map(genericChoice => {
                                return {
                                    uid: this.UniqueIdService.generate(),
                                    type: 'text',
                                    label: genericChoice.trim(),
                                    votes: 0,
                                    votesOverride: 0,
                                    collapsed: false,
                                    visibility: true
                                }
                            })
                        ].filter(choice => choice && choice.label)
                    });
                }
            }

        }

        processBulkInsert() {
            this.hideBulkInsert();
            this.items.push(...this.bulkQuestionsAndChoices);
            this.setCurrentQuestion(this.items.length - 1)
        }

        deleteQuestion(questionIndex, confirmed = false, resetPosition = true) {
            if (confirmed || confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.splice(questionIndex, 1);
                if (resetPosition) {
                    questionIndex = questionIndex > 0 ? questionIndex - 1 : questionIndex;
                    this.setCurrentQuestion(questionIndex);
                }
            }
        }

        getCurrentQuestion() {
            return this.currentQuestion;
        }

        isCurrentQuestion(uid) {
            return this.currentQuestion && this.currentQuestion.uid === uid;
        }

        setCurrentQuestion(index) {
            this.currentQuestion = this.items[index];
        }
    }
}
